import { render, staticRenderFns } from "./ContMyDatasources.vue?vue&type=template&id=7d50f437&scoped=true&lang=pug"
import script from "./ContMyDatasources.vue?vue&type=script&lang=js"
export * from "./ContMyDatasources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d50f437",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d50f437')) {
      api.createRecord('7d50f437', component.options)
    } else {
      api.reload('7d50f437', component.options)
    }
    module.hot.accept("./ContMyDatasources.vue?vue&type=template&id=7d50f437&scoped=true&lang=pug", function () {
      api.rerender('7d50f437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refactoring/ContMyDatasources.vue"
export default component.exports